module.exports = __webpack_public_path__ + "img/uy.8e443cd2.jpg";